import { cancleClick } from "./BillingNoteComponent";
import { FieldParams } from "./FieldObject";
import { FieldDataType, FormControlType } from "./Helper2";

export const GetDFPaymentHeaderObject = (props) => {
  const {
    docuList,
    onSelectDocument,
    docuFieldIdName,
    head,
    custClick,
    sectionId,
    disableSlip,
    disablePayDate,
  } = props;

  const maxWidth = "200px";

  if (sectionId === 1)
    return {
      [docuFieldIdName]: {
        ...new FieldParams(
          docuFieldIdName,
          "DocuId",
          true,
          FieldDataType.NUMERIC,
          FormControlType.HIDDEN,
        ),
      },

      BranchDocu: {
        ...new FieldParams(
          "DocuBranch",
          "ประเภทเอกสาร",
          true,
          FieldDataType.NUMERIC,
          FormControlType.SELECT,
        ),
        selectData: docuList,
        selectHasFirstOption: false,
        selectBuildObjectPath: "DocuBranch.BranchDocu",
        selectValueName: "DocuBrchId",
        selectDisplayName: "DocuType.DocuTypeName", // [docuList].DocuType.DocuTypeName
        onChange: onSelectDocument,
        disabled: head?.[docuFieldIdName] ? true : false,
      },
      DocuNo: {
        ...new FieldParams(
          "DocuNo",
          "เลขที่เอกสาร",
          true,
          FieldDataType.TEXT,
          null,
          head?.DocuNo ?? null,
        ),
        disabled: true, // head?.[docuFieldIdName] ? true : false,
      },
      DocuDate: {
        ...new FieldParams(
          "DocuDate",
          "วันที่เอกสาร",
          true,
          FieldDataType.DATE,
          FormControlType.DATE_PICKER,
        ),
        disabled: head?.[docuFieldIdName] ? true : false,
      },
    };
  else if (sectionId === 2)
    return {
      Customer: {
        ...new FieldParams(
          "Staff",
          "แพทย์",
          true,
          FieldDataType.NUMERIC,
          FormControlType.SEARCHER,
        ),
        tableColumnFieldName: "Staff.FullName",
        searchDisplayName: "FullName",
        searchValueName: "Staffid",
        searchButtonClick: custClick,
        searchCancelClick: cancleClick,
        hidden: true,
        labelStyle: { maxWidth, flex: "none" },
      },

      BillTo: {
        ...new FieldParams("BillTo", "ออกให้กับ", null, null, null),
        labelStyle: { maxWidth, flex: "none" },
      },
      Addr1: {
        ...new FieldParams("BillAddr1", "ที่อยู่", null, null, null),

        labelStyle: { maxWidth, flex: "none" },
      },

      Addr2: {
        ...new FieldParams("BillAddr2", "", null, null, null),
        labelStyle: { maxWidth, flex: "none" },
      },
      Phone: {
        ...new FieldParams("BillPhone", "เบอร์โทร", null, null, null),
        labelStyle: { maxWidth, flex: "none" },
      },
      DocuDate: {
        ...new FieldParams(
          "DocuDueDate",
          "วันที่นัดชำระ",
          true,
          FieldDataType.DATE,
          FormControlType.DATE_PICKER,
        ),
        // disabled: head?.[docuFieldIdName] ? true : false,
      },
    };
  else if (sectionId === 3) {
    return {
      CompleteDate: {
        ...new FieldParams(
          "CompleteDate",
          "วันที่ชำระ",
          true,
          FieldDataType.DATE,
          FormControlType.DATE_PICKER,
          head?.IsCompleted === false ? null : head?.CompleteDate,
        ),
        disabled: disablePayDate,
        allowNull: true,
      },
      CompleteSlipNo: {
        ...new FieldParams("CompleteSlipNo", "เลขสลิปโอน", null, null, null),
        labelStyle: { maxWidth, flex: "none" },
        disabled: disableSlip,
      },

      CompleteRemark: {
        ...new FieldParams(
          "PaymentRemark",
          "หมายเหตุ",
          null,
          null,
          FormControlType.TEXT_AREA,
        ),
        labelStyle: { maxWidth, flex: "none" },
        disabled: false,
      },
      // IsCompleted: {
      //   ...new FieldParams(
      //     "IsCompleted",
      //     "จ่ายแล้ว",
      //     null,
      //     null,
      //     FormControlType.CHECK_BOX,
      //     false
      //   ),
      //   labelStyle: { maxWidth, flex: "none" },
      //   disabled: false,
      //   type: "checkbox",
      // },
    };
  } else if (sectionId === 4) {
    return {
      Amount: {
        ...new FieldParams(
          "Amount",
          "ยอดรวม",
          true,
          FieldDataType.NUMERIC,
          FormControlType.DECIMAL_LOCK_VALUE,
        ),
        readOnly: true,
      },
    };
  }
};
